<template>
    <div id="TabContract">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="showPotentialReservation === true">
            <div class="dashboard-btm-section"> 
                <h5 class="color-darkblue font-semibold"> Online Reservations </h5>
                <div class="dashboard-module-btm-section basic-form-container"> 
                    <div :class="`loader${loaderClass}`" v-show="loading"></div>
                    <div class="table-responsive-sm">
                        <table aria-describedby="table" id="contact_table" class="table table-sm font-1">
                            <thead>
                                <tr class="table-header">
                                    <th>#Reference</th>
                                    <th>Customer</th>
                                    <th>Asset Type</th>
                                    <th>Credit Status</th>
                                    <th>Insurance Status</th>
                                    <template v-if="isAdmin === true">
                                    <th>Location</th>
                                    </template>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="pendingReservationArr != ''">
                                    <tr v-for="(reservation, index2) in pendingReservationArr" v-bind:key="index2">
                                        <td>
                                            <a class="color-blue" href="javascript:void(0)" v-on:click="selectPotentialAction(reservation.temp_booking_id ,reservation.temp_reservation_id ,flag='view')" title="View Pending Reservation">
                                                {{reservation.reference_no}}
                                            </a>
                                        </td>
                                        <td>{{ reservation.company }}</td>
                                        <td>{{ reservation.assetType }}</td>
                                        <td>{{ reservation.credit_status }}</td>
                                        <td>{{ reservation.insurance_status }}</td>
                                        <template v-if="isAdmin === true">
                                        <td>{{ reservation.location }}</td>
                                        </template>
                                        <td>{{ reservation.pickup_datetime}}</td>
                                        <td>{{ reservation.dropoff_datetime}}</td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td class="no-data-found" style="text-align:center" colspan="12">{{"No Data Found!"}}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                    <div class="btn-groups text-right"> 
                        <button type="submit" id="CreateCustomerBtn" class="btn btn-primary" v-on:click.prevent="viewAllBtnClicked('pending')" > <i class="fp-view"></i> View all
                        </button>
                    </div> 
                </div>
            </div> 
        </template>
        <template v-if="showRentalReservation === true">
            <hr class="light-hr" style="border-style:dashed;"/>
            <div class="dashboard-btm-section"> 
                <div class="title-section w-100 pull-left mb-3">
                    <h5 class="color-darkblue font-semibold pull-left"> Rental Reservations </h5>
                    <v-select class="close-remove w-25 pull-right" v-model="selectedDateRange" name="class_id" placeholder="Select Time."
                            label="text"
                            :options="dateRangeArr">
                    </v-select>
                </div>
                <div class="dashboard-module-btm-section clear mt-2">
                    <div :class="`loader${loaderClass}`" v-show="loading"></div>
                    <div class="table-responsive-sm">
                        <table aria-describedby="table" id="contact_table" class="table table-sm font-1">
                            <thead>
                                <tr class="table-header">
                                    <th>#Reference</th>
                                    <th>#Unit</th>
                                    <th>Customer</th>
                                    <th>Asset Type</th>
                                    <template v-if="isAdmin == true">
                                    <th>Location</th>
                                    </template>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="rentalReservationArr != ''">
                                    <tr v-for="(reservation, index2) in rentalReservationArr" v-bind:key="index2">
                                        <td>
                                            <a href="javascript:void(0)" class="color-blue" v-on:click="selectRentalAction(reservation.id ,reservation.truck_id ,flag='view', reservation.resvId)" title="View Reservation">
                                                {{ reservation.reference_no }}
                                            </a>
                                        </td>
                                        <td>{{ reservation.unit_no }}</td>
                                        <td>{{ reservation.company }}</td>
                                        <td>{{ reservation.assetType }}</td>
                                        <template v-if="isAdmin == true">
                                        <td>{{ reservation.location }}</td>
                                        </template>
                                        <td>{{ reservation.pickup_datetime}}</td>
                                        <td>{{ reservation.dropoff_datetime}}</td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td class="no-data-found" style="text-align:center" colspan="12">{{"No Data Found!"}}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                    <div class="btn-groups text-right"> 
                        <button type="submit" id="CreateCustomerBtn" class="btn btn-primary" v-on:click.prevent="viewAllBtnClicked('current')" > <i class="fp-view"></i> View all
                        </button>
                    </div> 
                </div> 
            </div> 
        </template>
    </div>
</template>
<script>
    import EventBus from "./event-bus";
    export default {
        name: "ReservationSummary",
        props: {
            reservationSummaryVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            pendingReservationArr: [],
            rentalReservationArr: [],
            showRentalReservation: false,
            showPotentialReservation: false,
            loading: false,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: "created_at",
                    type: "asc"
                },
                page: 1,
                perPage: 5
            },
            dateRangeArr: [{ value: 'current date', text: 'Current Date'}, { value: 'current week', text: 'Current Week'}, { value: 'next week', text: 'Next Week'}, { value: 'current month', text: 'Current Month'}],
            selectedDateRange: { value: 'current date', text: 'Current Date'},
            isAdmin: false
        }),
        watch:{
            selectedDateRange: function(selectedDateRange) {
                var self = this;
                
                if (self.selectedDateRange.value != undefined) {
                    self.loadRentalReservationList();
                }
                

            }
        },
        created: function() {

        },
        mounted: function() {

            var self = this;

            if(self.reservationSummaryVal == 'potentialreservationlist'){
                self.showPotentialReservation = true;
                self.loadPendingReservationList();
            }
            
            if(self.reservationSummaryVal == 'rentalreservationlist'){
                self.showRentalReservation = true;
                self.loadRentalReservationList();
            }

        },
        methods: {

            viewAllBtnClicked:function(redirectTo) {
                var self = this;
                self.$router.push({ name: 'RentalReservationList', query: { active: redirectTo }})
            },

            loadPendingReservationList: function() {
                
                var self = this;
                self.loading = true;
                
                var date = new Date();
                var offset = date.getTimezoneOffset();

                this.serverParams.columnFilters = '';

                $.ajax({
                    url: process.env.ROOT_API + "/pending_list_bookings",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data: {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: this.serverParams.columnFilters,
                        sort: this.serverParams.sort,
                        offset: offset,
                        flag: 'getPendingReservationSummary'
                    },
                    success: function(data) {
                        self.loading = false;
                        self.pendingReservationArr = [];

                        if (data.status == "success") {

                            if (data.content.row != undefined) {
                                self.pendingReservationArr = data.content.row;
                                self.isAdmin = data.isadmin;
                            }

                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'rsvt-summary-pending-list')
                    }
                });
            },
            loadRentalReservationList: function() {
                
                var self = this;
                self.loading = true;
                
                var date = new Date();
                var offset = date.getTimezoneOffset();

                self.serverParams.columnFilters = '';

                $.ajax({
                    url: process.env.ROOT_API + "/list_rental_reservation_summary",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data: {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        sort: self.serverParams.sort,
                        offset: offset,
                        date: self.selectedDateRange.value
                    },
                    success: function(data) {
                        self.loading = false;
                        self.rentalReservationArr = [];

                        if (data.status == "success") {
                            
                            if (data.content.row != undefined) {
                                self.rentalReservationArr = data.content.row;
                                self.isAdmin = data.isadmin;
                            }

                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'rsvt-summary-rental-list')
                    }
                });
            },
            selectPotentialAction: function(temp_booking_id, temp_resevation_id, flag) {
                var self = this;
                if (flag == "view") {
                    localStorage.setItem("temp_reservation_id", temp_resevation_id);
                    if (self.reservationVal == "unsyncbooking") {
                    self.flag = "unsyncbooking";
                    }
                    self.$router.push({
                        name: "PendingReservationContent",
                        params: { id: temp_booking_id, flag: self.flag }
                    });
                    
                }
            },
            selectRentalAction: function(id, truck_id, flag, resvId) {
                var self = this;
                if (flag == "view") {
                    localStorage.setItem("truck_id", truck_id);
                    localStorage.setItem("reservationId", resvId);

                    self.$router.push({
                    name: "ReservationContent",
                    params: { id: id, flag: self.flag }
                    });
                    
                }
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/ReservationSummary.vue